// extracted by mini-css-extract-plugin
module.exports = {"container":"RecommendList_container__wYtQW","recommendList":"RecommendList_recommendList__5_MGk","recommendItem":"RecommendList_recommendItem__1D33o"};